
import React from 'react';

export const ChevronLeftIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    chevron_left
  </span>
);